import { render, staticRenderFns } from "./_compositionLanguage.vue?vue&type=template&id=7ee867bf&scoped=true"
import script from "./_compositionLanguage.vue?vue&type=script&lang=js"
export * from "./_compositionLanguage.vue?vue&type=script&lang=js"
import style0 from "./_compositionLanguage.vue?vue&type=style&index=0&id=7ee867bf&prod&lang=less"
import style1 from "./_compositionLanguage.vue?vue&type=style&index=1&id=7ee867bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee867bf",
  null
  
)

export default component.exports